import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios';
import { RejectNegotiationValidationSchema } from '../schemas/rejectNegotiation.schema';

interface UseRejectNegotiationProps {
  negotiationId?: string
  onSuccess: (response: AxiosResponse) => void
  onError: (error: ErrorResponse) => void
}

export const useRejectNegotiation = ({
  negotiationId,
  onSuccess,
  onError,
}: UseRejectNegotiationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['rejectNegotiation', negotiationId],
    mutationFn: (formRejectNegotiation: RejectNegotiationValidationSchema) => {
      const payload = {
        observation: formRejectNegotiation.observation,
      }

      return privateAxios.put(`/client/negotiations/${negotiationId}/reject`, payload);
    },
    onSuccess,
    onError,
  })
}
